export const formatPhoneNumber = (phoneNumber: string): string => {
  const part1 = phoneNumber.slice(2, 4)
  const part2 = phoneNumber.slice(4, 9)
  const part3 = phoneNumber.slice(9)

  return `${part1} ${part2}-${part3}`
}
